import { API_URL_V2 } from '../../../utils/config';
import { setInstaPointBalance } from '../authentication/authentication-action';
import { makeApiCall } from '../common/common-action';

export function getInstaPoints(
  isLastTransactionAvailable = false,
  source_currency,
  destination_currency
) {
  let params = {};
  if (isLastTransactionAvailable) {
    params = {
      source_currency,
      destination_currency
    };
  }
  return async (dispatch) => {
    try {
      const response = await makeApiCall({
        method: 'get',
        url: `${API_URL_V2}/instapoint/balance`,
        withCredentials: true,
        params
      });
      if (response?.data?.success) {
        dispatch(setInstaPointBalance(response.data.data));
        return response.data.data;
      }
    } catch (error) {
      return { instapoints: 0 };
    }
  };
}
